export default {
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                type: 'input',
                placeholder: '客户订单号(支持批量查询，英文逗号或空格分开)',
                unfold: true,
                span: 5
            },
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '发车时间',
                value: 'actDepartTime',
                type: 'time',
                unfold: true,
                timeNum: 3,
                span: 6,
                startPlaceholder: '发车起始时间',
                endPlaceholder: '发车结束时间'
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table:
    {
        hasMaxBtnNum: true,
        maxBtnNum: 3,
        clickState: false,
        selectBtn: true,
        height: 400,
        columns: [
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: '180px',
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: '192px',
                sort: true
            },
            {
                label: '司机定位地址',
                prop: 'arrivalDriverAddress',
                type: 'custom',
                align: 'center',
                width: 220,
                sort: true
            },
            {
                label: '当前货站抵达方式',
                prop: 'arrivalWay',
                type: 'select',
                width: 150,
                optionNum: 'OTP_STATION_ARRIVAL_WAY',
                options: []
            },
            {
                label: '当前货站抵达状态',
                prop: 'arrivalStatus',
                type: 'select',
                width: 150,
                optionNum: 'OTP_ARRIVAL_STATUS',
                options: []
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '仓库第一货站里程',
                prop: 'navigationDistance',
                width: 180,
                sort: true
            },
            {
                label: '当前货站抵达时间',
                prop: 'arrivalTime',
                width: 200,
                sort: true
            },
            {
                label: '运抵操作人',
                prop: 'arrivalOperator',
                width: 180,
                sort: true
            },
            {
                label: '目的省',
                prop: 'receiverProvinceName',
                width: 120,
                sort: true
            },
            {
                label: '目的市',
                prop: 'receiverCityName',
                width: 120,
                sort: true
            },
            {
                label: '目的区',
                prop: 'receiverDistrictName',
                width: 120,
                sort: true
            },
            {
                label: '目的乡镇',
                prop: 'receiverTownName',
                width: 120,
                sort: true
            },
            {
                label: '线路名称',
                prop: 'lineName',
                width: 120,
                sort: true
            },
            {
                label: '网点名称',
                prop: 'networkName',
                width: 150,
                sort: true
            },
            {
                label: '签收状态',
                prop: 'signStatus',
                type: 'select',
                optionNum: 'SIGN_STATUS',
                options: [],
                width: '120px',
                sort: true
            },
            {
                label: '是否已转单',
                prop: 'isTransfered',
                align: 'center',
                width: 120,
                sort: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                width: '192px',
                sort: true
            },
            {
                label: '客户名称',
                prop: 'customerName',
                width: '200px',
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '200px',
                sort: true
            },
            {
                label: '收件地址',
                prop: 'receiverDetailAddr',
                width: '180px',
                sort: true
            },
            {
                label: '收货人手机号码',
                prop: 'receiverMobile',
                width: '140px',
                sort: true
            },
            {
                label: '运输单状态',
                prop: 'taskStatus',
                type: 'select',
                width: '140px',
                optionNum: 'TRANSPORT_STATUS',
                options: [],
                sort: true
            },
            {
                label: '当前货站',
                prop: 'lspTransferStationName',
                width: '140px',
                sort: true
            },
            {
                label: '转单车牌',
                prop: 'lspTransferVehicleCard',
                width: '140px',
                sort: true
            },
            {
                label: '物流单号',
                prop: 'expressNo',
                width: '140px',
                sort: true
            },
            {
                label: '物流公司名称',
                prop: 'logisticsCompanyName',
                width: '140px',
                sort: true
            },
            {
                label: '转单司机',
                prop: 'lspTransferDriver',
                width: '140px',
                sort: true
            },
            {
                label: '操作日志',
                align: 'center',
                prop: 'status',
                type: 'detail',
                buttonName: '操作日志',
                emitEvent: 'actionLog',
                width: '140px',
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '货站转单',
                size: 'small',
                event: 'transferOrder',
                ifHas: 'otp04140002'
            },
            {
                type: 'text',
                label: '撤回',
                size: 'small',
                event: 'withdraw',
                ifHas: 'otp04140003'
            },
            {
                type: 'text',
                label: '指派末端司机',
                size: 'small',
                event: 'assignDriver',
                ifHas: 'otp04140004'
            },
            {
                type: 'text',
                label: '回单上传',
                size: 'small',
                event: 'receiptUpload',
                ifHas: 'otp04140005'
            },
            {
                type: 'text',
                label: '转快递',
                size: 'small',
                event: 'express'
            },
            {
                type: 'text',
                label: '抵达货站',
                size: 'mini',
                event: 'arrivalConfirmation'
            }
        ],
        leftOperation: true,
        leftWidth: 270
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    // 高级搜索配置项
    searchTotalTitle: [
        {
            name: '线路名称',
            value: 'lineName',
            type: 'advance',
            unfold: false,
            span: 3,
            advanceConfig: [
                { prop: 'lineMergeId', 'value': '线路编码' },
                { prop: 'lineMergeName', 'value': '线路名称' }
            ],
            method: 'post',
            paramType: true,
            prefix: '/api-opms/',
            advanceUrl: `opms/searchMergeLine`,
            cbParams: ['lineMergeId#lineCode', 'lineMergeName#lineName'],
            tableConfig: [
                { prop: 'lineMergeId', 'value': '线路编码' },
                { prop: 'lineMergeName', 'value': '线路名称' }
            ]
        },
        {
            name: '物流公司',
            value: 'logisticsCompanyName',
            type: 'advance',
            advanceConfig: [
                { prop: 'logisticsCompanyName', value: '物流公司名称' },
                { prop: 'logisticsCompanyCode', value: '物流公司编码' }
            ],
            tableConfig: [
                { prop: 'logisticsCompanyName', value: '物流公司名称' },
                { prop: 'logisticsCompanyCode', value: '物流公司编码' }
            ],
            prefix: '/api-antms/common',
            advanceUrl: '/lsp/transfer/logisticsCompanyQuery',
            method: 'post',
            paramType: true,
            cbParams: ['logisticsCompanyCode#logisticsCompanyCode', 'logisticsCompanyName#logisticsCompanyName']
        },
        {
            name: "目的地省",
            value: "receiverProvinceName",
            type: "advance",
            advanceConfig: [
                { prop: "ebplNameCn", "value": "目的地省名称" },
                { prop: "ebplCode", "value": "目的地省编码" }
            ],
            tableConfig: [
                { prop: "ebplNameCn", "value": "目的地省名称" },
                { prop: "ebplCode", "value": "目的地省编码" }
            ],
            cbParams: [
                "ebplCode#receiverProvinceCode",
                "ebplNameCn#receiverProvinceName"
            ],
            advanceUrl: "/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000",
            advanceCode: "receiverProvinceCode"
        },
        {
            name: "目的地市",
            value: "receiverCityName",
            type: "advance",
            advanceConfig: [
                { prop: "ebplNameCn", "value": "目的地市名称" },
                { prop: "ebplCode", "value": "目的地市编码" }
            ],
            tableConfig: [
                { prop: "ebplNameCn", "value": "目的地省名称" },
                { prop: "ebplCode", "value": "目的地市编码" }
            ],
            cbParams: [
                "ebplCode#receiverCityCode",
                "ebplNameCn#receiverCityName"
            ],
            advanceUrl: "/searchEbPlacePage?ebplType=PLACE_CITY",
            advanceCode: "receiverCityCode"
        },
        {
            name: "目的地区",
            value: "receiverDistrictName",
            type: "advance",
            advanceConfig: [
                { prop: "ebplNameCn", "value": "目的地区名称" },
                { prop: "ebplCode", "value": "目的地区编码" }
            ],
            tableConfig: [
                { prop: "ebplNameCn", "value": "目的地区名称" },
                { prop: "ebplCode", "value": "目的地区编码" }
            ],
            cbParams: [
                "ebplCode#receiverDistrictCode",
                "ebplNameCn#receiverDistrictName"
            ],
            advanceUrl: "/searchEbPlacePage?ebplType=PLACE_DISTRICT",
            advanceCode: "receiverDistrictCode"
        },
        {
            name: "目的地乡镇",
            value: "receiverTownName",
            type: "advance",
            advanceConfig: [
                { prop: "ebplNameCn", "value": "目的地乡镇名称" },
                { prop: "ebplCode", "value": "目的地乡镇编码" }
            ],
            tableConfig: [
                { prop: "ebplNameCn", "value": "目的地乡镇名称" },
                { prop: "ebplCode", "value": "目的地乡镇编码" }
            ],
            cbParams: [
                "ebplCode#receiverTownCode",
                "ebplNameCn#receiverTownName"
            ],
            advanceUrl: "/searchEbPlacePage?ebplType=PLACE_STREET",
            advanceCode: "receiverTownCode"
        },
        {
            name: '网点名称',
            value: 'networkName',
            type: 'advance',
            unfold: false,
            advanceConfig: [
                { 'prop': 'netName', 'value': '网点名称' },
                { 'prop': 'netCode', 'value': '网点编码' }
            ],
            tableConfig: [
                { 'prop': 'netName', 'value': '网点名称' },
                { 'prop': 'netCode', 'value': '网点编码' }
            ],
            advanceUrl: '/netInfos',
            cbParams: ['netCode#networkCode', 'netName#networkName'],
            advanceCode: 'advanceCode'
        },
        {
            name: '物流单号',
            value: 'expressNo',
            type: 'input'
        },
        {
            name: '自动匹配货站抵达时间',
            value: 'arrivalTime',
            type: 'time',
            startPlaceholder: '抵达开始时间',
            endPlaceholder: '抵达结束时间'
        },
        {
            name: '发运类型',
            value: 'shippingType',
            optionNum: 'TMS_SHIPPING_TYPE',
            type: 'select',
            options: []
        },
        {
            name: '自动匹配货站抵达状态',
            value: 'arrivalStatus',
            optionNum: 'OTP_ARRIVAL_STATUS',
            type: 'select',
            options: []
        },
        {
            name: '自动匹配货站抵达方式',
            value: 'arrivalWay',
            optionNum: 'OTP_STATION_ARRIVAL_WAY',
            type: 'select',
            options: []
        },
        {
            name: "签收状态",
            value: "signStatusList",
            type: "select",
            multiple: true, // 多选
            filterable: true,
            optionNum: "SIGN_STATUS",
            options: []
        },
        {
            name: "运输单状态",
            value: "taskStatusList",
            type: "select",
            multiple: true, // 多选
            filterable: true,
            optionNum: "TRANSPORT_STATUS",
            options: []
        },
        {
            name: "是否已转单",
            value: "isTransfered",
            type: "select",
            filterable: true,
            optionNum: "",
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '服务平台',
            value: 'siteName',
            multiple: true,
            maxSelect: 5,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNo', value: '服务平台编码' },
                { prop: 'escoCompanyNameCn', value: '服务平台名称' }
            ],
            advanceUrl: '/searchPlatform',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            type: 'advance'
        },
    ]
}
